import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Service } from 'src/app/core/jsonapi/service';
import { UserHistory } from '../_types/user-history';
import { UserActivityMetric } from '../_types/user-activity-metric';
import { UserActivityHourly } from '../_types/user-activity-hourly';

@Injectable({
    providedIn: 'root'
})
export class UserHistoriesService extends Service<UserHistory> {
    public override type = 'userHistories';
    public override url = 'auth/userHistories';

    /// Contadores de actividad por tipo de evento para las tarjetas del panel.
    public getMetrics(dateFrom: Date, dateTo: Date, userId: string | null = null, userTypeCode: string | null = null): Observable<UserActivityMetric[]> {
        let url = this.getAPIUrl() + '/metrics?dateFrom=' + dateFrom.toISOString() + '&dateTo=' + dateTo.toISOString();
        if (userId != null) url += '&userId=' + userId;
        if (userTypeCode != null) url += '&userTypeCode=' + encodeURIComponent(userTypeCode);

        this.loaderService.skipRequest(url);

        return this.http.get<UserActivityMetric[]>(url);
    }

    /// Reparto de la actividad por hora del día. Se manda el desfase horario del navegador porque las
    /// fechas se guardan en UTC y la franja de trabajo hay que leerla en hora local.
    public getHourlyActivity(dateFrom: Date, dateTo: Date, userId: string | null = null, userTypeCode: string | null = null): Observable<UserActivityHourly> {
        //getTimezoneOffset devuelve los minutos que hay que sumar a la hora local para llegar a UTC,
        //con el signo invertido respecto a lo que espera el backend
        const utcOffsetMinutes = -new Date().getTimezoneOffset();

        let url = this.getAPIUrl() + '/hourly?dateFrom=' + dateFrom.toISOString() + '&dateTo=' + dateTo.toISOString() + '&utcOffsetMinutes=' + utcOffsetMinutes;
        if (userId != null) url += '&userId=' + userId;
        if (userTypeCode != null) url += '&userTypeCode=' + encodeURIComponent(userTypeCode);

        this.loaderService.skipRequest(url);

        return this.http.get<UserActivityHourly>(url);
    }
}
